import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { Guid } from '@core/utils/guid';
import { Review } from '@shared/models/review';
import { Advantage, DigitalCourse, DigitalCourseFilter, DigitalCourseQueryParams, Question } from '../../models';
import { DigitalCourseState } from '../digital-course.state';
import * as fromAction from '../digital-course.action';
import * as fromSelector from '../digital-course.selector';

@Injectable()
export class DigitalCourseStoreService {
  constructor(private store: Store<DigitalCourseState>) {}

  fetchAllDigitalCourses(queryParams: DigitalCourseQueryParams, filter?: DigitalCourseFilter): void {
    this.store.dispatch(fromAction.FetchDigitalCourses({ queryParams, filter }));
  }

  fetchDigitalCourse(courseId: string): void {
    this.store.dispatch(fromAction.FetchDigitalCourse({ courseId }));
  }

  getAllDigitalCourse(): Observable<DigitalCourse[]> {
    return this.store.pipe(select(fromSelector.getAllDigitalCourses));
  }

  getDigitalCourse(courseId: string): Observable<DigitalCourse> {
    if (Guid.IsGuid(courseId)) {
      return this.store.select(fromSelector.getDigitalCourseById(courseId));
    } else {
      return this.store.select(fromSelector.getDigitalCourseBySlug(courseId));
    }
  }

  addSelectedDigitalCourse(digitalCourseId: string): void {
    this.store.dispatch(fromAction.AddSelectedDigitalCourse({ digitalCourseId }));
  }

  getSelectedDigitalCourse(): Observable<DigitalCourse> {
    return this.store.pipe(select(fromSelector.getSelectedDigitalCourse));
  }

  removeSelectedDigitalCourse(): void {
    this.store.dispatch(fromAction.RemoveSelectedDigitalCourse());
  }

  fetchCourseAdvantage(courseId: string): void {
    this.store.dispatch(fromAction.FetchCourseAdvantage({ courseId }));
  }

  getCourseAdvantage(): Observable<Advantage[]> {
    return this.store.select(fromSelector.getAdvantages);
  }

  fetchCourseQuestion(courseId: string): void {
    this.store.dispatch(fromAction.FetchCourseQuestion({ courseId }));
  }

  getCourseQuestion(): Observable<Question[]> {
    return this.store.select(fromSelector.getQuestions);
  }

  addError(error: any): void {
    this.store.dispatch(fromAction.AddError(error));
  }

  submitCourseReview(id: string, review: Review): void {
    this.store.dispatch(fromAction.SaveCourseReview({ courseId: id, review: review }));
  }
}
